import * as types from './types';

export const setNotificationTypesLoading = isLoading => ({
  type: types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_TYPES_LOADING,
  isLoading
});

export const setNotificationSummaryLoading = (notificationType, isLoading) => ({
  type: types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_SUMMARY_LOADING,
  notificationType,
  isLoading
});

export const setNotificationDisableSwitching = isSwitching => ({
  type: types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_DISABLE_SWITCHING,
  isSwitching
});

export const setNotificationEmailTemplateUpdating = isUpdating => ({
  type: types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_EMAIL_TEMPLATE_UPDATING,
  isUpdating
});

export const setNotificationTypes = notificationTypes => ({
  type: types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_TYPES,
  notificationTypes
});

export const setNotificationSummary = notificationSummary => ({
  type: types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_SUMMARY,
  notificationSummary
});

export const setNotificationEmailTemplate = notificationEmailTemplate => ({
  type: types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_EMAIL_TEMPLATE,
  notificationEmailTemplate
});

export const setNotificationDisabled = isDisabledNotification => ({
  type: types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_SET_DISABLED,
  isDisabledNotification
});

export const resetNotificationSummary = () => ({
  type: types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_RESET_SUMMARY
});

export const getNotificationTypes = schoolId => ({
  type: types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_GET_TYPES,
  schoolId
});

export const getNotificationSummary = (schoolId, notificationType) => ({
  type: types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_GET_SUMMARY,
  schoolId,
  notificationType
});

export const updateNotificationSummary = (schoolId, notificationType, notificationEmailTemplate) => ({
  type: types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_UPDATE_EMAIL_TEMPLATE,
  schoolId,
  notificationType,
  notificationEmailTemplate
});

export const toggleNotificationDisabled = (schoolId, notificationType, isDisabledNotification) => ({
  type: types.SCHOOL_ADMIN_EMAILS_NOTIFICATION_TOGGLE_DISABLE,
  schoolId,
  notificationType,
  isDisabledNotification
});


// WEBPACK FOOTER //
// ./src/actions/school-admin/emails/index.js